import { useEffect, useState } from 'react'

import Bugsnag from '@bugsnag/js'
import { useRouteError } from 'react-router'
import { v4 as uuidv4 } from 'uuid'

import { errorStack } from './helpers'
import { NetworkErrorNotification } from './NetworkErrorNotification'
import { ComponentError } from '~/components/ErrorBoundary/ComponentError'
import PageNotFound from '~/components/PageNotFound'
import { useNotification } from '~/hooks/useNotification'
import { Environment } from '~/types/app'
import { isExpectedHttpStatus, isNetworkError } from '~/utils/api'

export const ErrorBoundaryComponent = () => {
  const error: Error | any = useRouteError()
  const [errorId, setErrorId] = useState<string>()

  const { flashError } = useNotification()

  useEffect(() => {
    const uniqueErrorId = uuidv4().split('-')[0]
    setErrorId(uniqueErrorId)

    if (isNetworkError(error?.status)) {
      flashError({
        message: <NetworkErrorNotification
          status={error.status}
          statusText={error.statusText}
          errorId={uniqueErrorId}
        />,
        dismiss: true,
        duration: 'Infinity',
      })
    }

    if (window['ENV']?.bugsnagApiKey && window['ENV']?.env !== Environment.LOCAL && error) {
      const errorMessage = errorStack(error)
      const newError = new Error(errorMessage)
      Bugsnag?.notify(
        newError,
        (event) => {
          if (uniqueErrorId) {
            event.addMetadata('error', {
              id: uniqueErrorId,
            })
          }
          event.groupingHash = errorMessage
        })
    }
  }, [error])

  if (isExpectedHttpStatus(error?.status, 404)) {
    return <PageNotFound />
  }

  return <ComponentError errorId={errorId} />
}